import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';

const CommissionPaymentSuccess = () => {
    const location = useLocation();
    const history = useHistory();

    // Parse query parameters from the URL
    const queryParams = new URLSearchParams(location.search);
    const session_id = queryParams.get('session_id');
    const type = queryParams.get('type');

    // Get current date/time in American format (MM/DD/YYYY, 12-hour AM/PM)
    const transactionDate = new Date().toLocaleString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
    });

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="min-h-screen bg-light d-flex align-items-center justify-content-center " style={{ minHeight: '100vh' }}>
                        <div className="card shadow-lg border-0 rounded-lg p-4 text-center" style={{ maxWidth: '450px', width: '100%' }}>

                            {/* Success Icon */}
                            <div className="d-flex justify-content-center mb-4">
                                <div className="bg-success bg-opacity-10 p-3 rounded-circle" style={{ backgroundColor: '#d1e7dd', borderRadius: '50%' }}>
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#198754" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                </div>
                            </div>

                            <h2 className="fw-bold text-dark mb-2">Payment Successful!</h2>
                            <p className="text-muted mb-4">
                                Your {type === 'commission' ? 'commission' : 'payment'} has been processed successfully.
                            </p>

                            {/* Info Box */}
                            <div className="bg-light rounded p-3 mb-4 text-start border">
                                <div className="mb-2">
                                    <small className="text-uppercase fw-bold text-secondary tracking-wider" style={{ fontSize: '0.7rem' }}>Payment ID</small>
                                    <p className="small font-monospace text-primary mb-0 text-break">{session_id || "N/A"}</p>
                                </div>

                                <hr className="my-2 opacity-50" />

                                <div>
                                    <small className="text-uppercase fw-bold text-secondary tracking-wider" style={{ fontSize: '0.7rem' }}>Time</small>
                                    <p className="small text-dark mb-0">{transactionDate}</p>
                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="d-grid gap-2">
                                <button
                                    onClick={() => history.push('/dashboard')}
                                    className="btn btn-primary fw-bold py-2 shadow-sm"
                                >
                                    Go to Dashboard
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommissionPaymentSuccess;